import {
  FETCH_USER_KUDOS_FOR_COURSE_START,
  FETCH_USER_KUDOS_FOR_COURSE_SUCCESS,
  FETCH_USER_KUDOS_FOR_COURSE_FAILURE,
} from './actions';

import { ResourceApi } from '../../resource/Resource';
import { currentUserIdSelector } from '../Auth/selectors';
import { selectCurrentCoursePath } from '../Courses/selectors';
import { USER_RESOURCE } from '../resourceNames';
import { selectKudosByCurrentCourseFetchStatus } from './selectors';
import { FetchStatus } from './constants';

export const fetchUserKudos = () => {
  return (dispatch, getState) => {
    const state = getState();
    const userId = currentUserIdSelector(state);
    const coursePath = selectCurrentCoursePath(state);
    const fetchStatus = selectKudosByCurrentCourseFetchStatus(state);

    if (userId && fetchStatus === FetchStatus.START) {
      dispatch({
        type: FETCH_USER_KUDOS_FOR_COURSE_START,
        coursePath,
      });

      ResourceApi.read(USER_RESOURCE, userId, 'getKudosForCourse', {
        coursePath,
      }).then(
        (kudos) => {
          dispatch({
            type: FETCH_USER_KUDOS_FOR_COURSE_SUCCESS,
            kudos,
            coursePath,
          });
        },
        (error) => {
          dispatch({
            type: FETCH_USER_KUDOS_FOR_COURSE_FAILURE,
            error,
            coursePath,
          });
          throw error;
        }
      );
    }
  };
};

export const loadCurrentUserKudos = (dispatch) => {
  return dispatch(fetchUserKudos());
};
